/*
 * @author Sergey Kuzhavskiy <Praffesor>
 */
angular.module('data.home-zone', []);
